import { any } from "prop-types"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { AnularSolicitudCambioHorario, ObtenerInformacionGeneralSolCambioHorario, SolicitarCambioHorarioCreacion, SolicitarFormulario } from "./FunctionSolCambioHorarioPRN"
import { EmpleadoHorario, InformacionGeneralSolicitudes, SolicitudCambioHorarioIngresada, SolicitudPost } from "./TypesCambioHorarioPRN"
import { authenticationService } from "../../../services/authentication.service"
import { alertService } from "components/Varios/alert_service"

import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { FileInfoUrl, ResponseRequest } from "../../Types/GeneralTypes"
import InputFileUpload from "../../Varios/InputFileUpload"
import { formatDateToString, PruebaSolucion2, SumarDiasFecha, SumarMesesFecha, toHoursAndMinutes } from "../../../functions/DatesFunctions"
import Datepicker from "../../Varios/Datepicker"
import { isFeriado, isFeriadoFilter, isWeekday } from "../../../functions/CalendarFunctions"
import add from 'date-fns/add'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import { ScrollToTop } from "../../../functions/LayoutFunctionst"
import AlertNew, { TiposAlerta } from "../../Varios/AlertNew"
import ModalVistaPreviaDocumentosAccion from "../../Varios/Modals/ModalVistaPreviaDocumento"
import ModalConfirmacion from "../../Varios/Modals/ModalConfirmacion"
import { formatoFecha } from "../../Admin/Inicio-Admin/Dashboard_Individual_Admin"
import { DownloadDocument, GetDocumentVistaPrevia } from "../../../helpers/files"
import Cargando from "../../Varios/Cargando"
import TableHistorialSolicitudCambioHorario from "./TablaHistorialSolicitudCambioHorario"
import { UserData } from "../../Sidebar/Sidebar_Principal"
import ModalVistaPreviaDocumentos from "../../Varios/Modals/ModalVistaPreviaDocumentos"

type StateSolCambioHorario = {
    datosGenerales: InformacionGeneralSolicitudes,
    loadingDG: boolean,
    mensajeError: string,
    idRegimenLaboral: number[],
    fechaControlHorario: Date,
    puedeSolicitarPorHorario: boolean
}

type StateModalHistoricoDetalle = {
    loadingInformacion: boolean,
    anio: number,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateEmpleadoHorario = {
    idpersonahorario: number,
    idhorariolaboral: number,
    fechaingreso: string | null,
    fechaVigDesde: string | null,
    fechaVigHasta: string | null,
    horaEntrada: string,
    horaSalida: string,
}
type stateModalFormulario = {
    url: string,
    loadingFormulario: boolean,
    tituloModal: string,
    content: HTMLElement | undefined
    solicitudNueva?: SolicitudPost | undefined
}

type stateModalConfirmacion = {
    showModal: boolean,
    solicitud?: SolicitudPost,
    content: HTMLElement | undefined
    tituloModal: string | null,
}

type stateModal = {
    showModal: boolean,
    solicitud?: SolicitudCambioHorarioIngresada,
    content: HTMLElement | undefined

}

export default function SolicitudCambioHorario() {

    /*const defaultStateEmpHorario: StateEmpleadoHorario = {
        idpersonahorario: 0,
        idhorariolaboral: 0,
        fechaingreso: "",
        fechaVigDesde: "",
        fechaVigHasta: "",
        horaEntrada: "",
        horaSalida: "",
    }

    const defaultState: StateSolCambioHorario = {
        datosGenerales: {
            feriados: [],
            historialSolicitudes: [], tieneAcuerdoMediosElectronicos: true,
            empHorario: [],
            horaInicioAlmuerzo: "",
            horaFinAlmuerzo: "",
            tiempoAlmuerzo: "",
            solicitudesIngresadas:[]
        },
        loadingDG: false,
        mensajeError: "",
        idRegimenLaboral: [],
        fechaControlHorario: new Date(),
        puedeSolicitarPorHorario: false
    }

    const defaultStateModalHistoricoDetalle: StateModalHistoricoDetalle = {
        loadingInformacion: false,
        anio: -1,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalFormulario: stateModalFormulario = {
        url: "",
        loadingFormulario: false,
        tituloModal: 'Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido',
        content: undefined,
        solicitudNueva: undefined
    }

    const defaultStateModalConfirmacion: stateModalConfirmacion = {
        solicitud: undefined,
        showModal: false,
        content: undefined,
        tituloModal: 'Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido',
    }

    const defaultStateModal: stateModal = {
        solicitud: undefined,
        showModal: false,
        content: undefined
    }

    const datosUsuario = authenticationService.currentUserValue.token;

    const [stateSolCambioHorario, setstateSolCambioHorario] = useState<StateSolCambioHorario>(defaultState)
    const [stateModalHistoricoDetalle, setstateModalHistoricoDetalle] = useState<StateModalHistoricoDetalle>(defaultStateModalHistoricoDetalle)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)
    const [stateModalFormulario, setstateModalFormulario] = useState<stateModalFormulario>(defaultStateModalFormulario)
    const [stateModalConfirmacion, setstateModalConfirmacion] = useState<stateModalConfirmacion>(defaultStateModalConfirmacion);
    const [stateModal, setstateModal] = useState<stateModal>(defaultStateModal);

    const [mensajeError, setMensajeError] = useState<string>("")
    const [errorHoras, seterrorHoras] = useState<string | null>("")

    const [horaEntradaAnterior, sethoraEntradaAnterior] = useState<string>("")
    const [horaSalidaAnterior, sethoraSalidaAnterior] = useState<string>("")
    const [fechaDesdeAnterior, setfechaDesdeAnterior] = useState<string | null>(null)
    const [fechaHastaAnterior, setfechaHastaAnterior] = useState<string | null>(null)
    const [feriados, setFeriados] = useState<Array<Date>>([])

    const [fechaDesdeNueva, setfechaDesdeNueva] = useState<Date | null>(null)
    const [horaDesde, setHoraDesde] = useState<string | null>("")
    const [horaHasta, setHoraHasta] = useState<string | null>("")
    const [observacion, setObservacion] = useState<string>("")
    const [horasSolicitadas, sethorasSolicitadas] = useState<string | null>("")

    const HORAS_TRABAJO_POR_DIA = 6;
    const RANGO_INICIO_ALMUERZO = stateSolCambioHorario.datosGenerales.horaInicioAlmuerzo
    const RANGO_FIN_ALMUERZO = stateSolCambioHorario.datosGenerales.horaFinAlmuerzo

    const [horaMinPermitida, sethoraMinPermitida] = useState<string>("07:00")
    const [horaMaxPermitida, sethoraMaxPermitida] = useState<string>("15:30")
    const HORA_MAX_FIN_PERMITIDA = "15:30"
    const TIEMPO_ALMUERZO = stateSolCambioHorario.datosGenerales.tiempoAlmuerzo
    const maxLength = 140;

    const MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS: string = "La solicitud no puede ser envíada por este medio porque no ha firmado el acuerdo de medios electrónicos. Por lo tanto, luego de dar click en aceptar, debe imprimir la presente solicitud, hacerla firmar físicamente por el directivo de su unidad y entregarla en la Unidad de Talento Humano";
    const MENSAJE_ADVERTENCIA_CAMBIO_HORARIO = "El nuevo horario aplicará una vez que el directivo haya autorizado la solicitud.";


    function HandleErrorInformacionGeneral(message?: string) {
        const mensaje = message ?? "Ha ocurrido un error al intentar obtener informacion de sus solicitudes"
        alertService.error(mensaje)
    }

    async function ObtenerDatosGenerales() {
        setstateSolCambioHorario({ ...stateSolCambioHorario, loadingDG: true })
        const respuesta = await ObtenerInformacionGeneralSolCambioHorario(HandleErrorInformacionGeneral)
        const listaRegimenServidor: number[] = authenticationService.currentUserValue.regimen_usuario;
        if (respuesta.status === 200) {
            setstateSolCambioHorario({ ...defaultState, datosGenerales: respuesta.dataResponse, loadingDG: false, idRegimenLaboral: listaRegimenServidor })
        }
        else {
            setstateSolCambioHorario({ ...defaultState, loadingDG: false, mensajeError: respuesta.errorMessage ?? "" })
        }
    }

    useEffect(() => {
        ObtenerDatosGenerales();
    }, [])

    useEffect(() => {
        if (stateSolCambioHorario.idRegimenLaboral[0] == 7 || stateSolCambioHorario.idRegimenLaboral[0] == 8) {
            sethoraMinPermitida("08:00")
            sethoraMaxPermitida("16:30")
        }
    }, [stateSolCambioHorario])

    useEffect(() => {
        if (stateSolCambioHorario.datosGenerales.empHorario.length == 0) {
            setMensajeError("Usted no tiene un permiso de cuidado del recién nacido en curso")
        } else {
            sethoraEntradaAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].horaEntrada)
            sethoraSalidaAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].horaSalida)
            setfechaDesdeAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].fechaVigDesde)
            setfechaHastaAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].fechaVigHasta)
            setFeriados(stateSolCambioHorario.datosGenerales.feriados)
            setMensajeError("")
        }

    }, [stateSolCambioHorario])

    function OnChangeHoraDesde(e: any) {
        setHoraDesde(e.target.value);
    }

    function OnChangeHoraHasta(e: any) {
        setHoraHasta(e.target.value);
    }

    const handleObservacionChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            setObservacion(valor);
        }

    };

    const DatePickerFechaDesde = useCallback((permiso: boolean) => {
        const feriadosFechas = feriados.map((val, ind) => {
            return new Date(val)
        })

        const fechaDesdeAnteriorDate = fechaDesdeAnterior ? new Date(fechaDesdeAnterior) : "";
        const fechaHastaAnteriorDate = fechaHastaAnterior ? new Date(fechaHastaAnterior) : null;

        var excludeDates = [...feriadosFechas];
        const fechaMinima = SumarDiasFecha(fechaDesdeAnteriorDate, 1);
        const fechaMaxima = fechaHastaAnteriorDate


        const handleChangeFechaDesde = (e: Date) => {
            setfechaDesdeNueva(e)
        };

        return (
            <Datepicker
                value={fechaDesdeNueva}
                disabled={!permiso}
                name="fechadesde"
                id="fechadesde"
                onChange={handleChangeFechaDesde}
                min={fechaMinima}
                max={fechaMaxima}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, feriados)}
                dayClassName={(date: Date) => isFeriado(date, feriados)}
            />
        )
    }, [feriados, fechaDesdeNueva]);

    const inputHoraDesde = useCallback(
        () => {
            return (
                <Input type="time" className="inputTime" value={horaDesde} onChange={(e) => OnChangeHoraDesde(e)} style={{ padding: "5px 1px" }} />
            )
        },
        [horaDesde]
    )

    const inputHoraHasta = useCallback(
        () => {
            return (
                <>
                    <Input disabled={(horaDesde !== undefined && horaHasta === undefined && errorHoras !== "") || horaDesde === undefined || horaDesde === ""} type="time" className="inputTime" min={"08:01"} max={"16:30"} value={horaHasta} onChange={(e) => OnChangeHoraHasta(e)} style={{ padding: "5px 1px" }} />
                </>
            )
        },
        [horaDesde, horaHasta, errorHoras]
    )
    useEffect(() => {

        if ((horaDesde !== undefined && horaDesde !== "" && horaDesde !== null)) {

            const fechaEscogida = new Date();
            const [hora_entrada, minuto_entrada] = horaDesde.split(":");
            const [hora_entrada_permitida, minuto_entrada_permitida] = horaMinPermitida.split(":");
            const horaEntradaDelDia = add(fechaEscogida, { hours: +hora_entrada, minutes: +minuto_entrada })
            const horaEntradaPermitidaDelDia = add(fechaEscogida, { hours: +hora_entrada_permitida, minutes: +minuto_entrada_permitida })
            if (horaEntradaDelDia < horaEntradaPermitidaDelDia) {
                seterrorHoras("La hora de entrada no puede ser menor a la hora permitida por su régimen.")
            } else {
                seterrorHoras("")
            }
        }
    }, [horaDesde])

    useEffect(() => {

        if ((horaHasta !== undefined && horaHasta !== "" && horaHasta !== null)) {

            const fechaEscogida = new Date();
            const [hora_salida, minuto_salida] = horaHasta.split(":");
            const [hora_salida_permitida, minuto_salida_permitida] = horaMaxPermitida.split(":");
            const horaSalidaDelDia = add(fechaEscogida, { hours: +hora_salida, minutes: +minuto_salida })
            const horaSalidaPermitidaDelDia = add(fechaEscogida, { hours: +hora_salida_permitida, minutes: +minuto_salida_permitida })
            if (horaSalidaDelDia > horaSalidaPermitidaDelDia) {
                seterrorHoras("La hora de salida no puede ser maypor a la hora permitida por su régimen.")
            } else {
                seterrorHoras("")
            }
        }
    }, [horaHasta])

    useEffect(() => {

        if ((horaDesde !== undefined && horaDesde !== "" && horaDesde !== null) && (horaHasta !== undefined && horaHasta !== "" && horaHasta !== null)) {

            const fechaEscogida = new Date();

            const horaDesdeAnterior = stateSolCambioHorario.datosGenerales.empHorario[0].horaEntrada
            const horaHastaAnterior = stateSolCambioHorario.datosGenerales.empHorario[0].horaSalida

            const [hora_entrada, minuto_entrada] = horaDesde.split(":");
            const [hora_salida, minuto_salida] = horaHasta.split(":");

            const [hora_entrada_permitida, minuto_entrada_permitida] = horaMinPermitida.split(":");
            const [hora_salida_permitida, minuto_salida_permitida] = horaMaxPermitida.split(":");

            const tiempoAlmuerzo = TIEMPO_ALMUERZO.split(':');
            const tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);

            const horaEntradaDelDia = add(fechaEscogida, { hours: +hora_entrada, minutes: +minuto_entrada })
            const horaSalidaDelDia = add(fechaEscogida, { hours: +hora_salida, minutes: +minuto_salida })

            const horaEntradaPermitidaDelDia = add(fechaEscogida, { hours: +hora_entrada_permitida, minutes: +minuto_entrada_permitida })
            const horaSalidaPermitidaDelDia = add(fechaEscogida, { hours: +hora_salida_permitida, minutes: +minuto_salida_permitida })


            const diferenciaHorasHorarioLaboral = (+differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia)) / 60;
            const diferenciaMinutos = +differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia);
            const diferencia = toHoursAndMinutes(diferenciaMinutos - tiempoAlmuerzoMinutos);
            sethorasSolicitadas(diferencia);
            if (diferenciaHorasHorarioLaboral < 0) {
                seterrorHoras("La hora de salida debe de ser mayor que la hora de entrada.")
            } else if (diferenciaHorasHorarioLaboral > 0 && diferenciaHorasHorarioLaboral != 6.5) {
                seterrorHoras("El horario laboral debe de tener una duración de 6 horas.")
            } else if (diferenciaHorasHorarioLaboral > 0 && diferenciaHorasHorarioLaboral == 6.5 && horaDesde == horaDesdeAnterior && horaHasta == horaHastaAnterior) {
                seterrorHoras("La hora de entrada o la hora de salida deben de ser diferentes al horario ya existente.")
            } else if (horaEntradaDelDia < horaEntradaPermitidaDelDia) {
                seterrorHoras("La hora de entrada no puede ser menor a la hora permitida por su régimen.")
            } else if (horaSalidaDelDia > horaSalidaPermitidaDelDia) {
                seterrorHoras("La hora de salida no puede ser menor a la hora permitida por su régimen.")
            } else {
                seterrorHoras("")
            }
        }
    }, [horaDesde, horaHasta])


    function GetHtmlSolicitudIngresada(solicitudes: SolicitudCambioHorarioIngresada[]) {
        console.log(solicitudes)
        const htmlRowsSolicitudesPermisosIngresados = solicitudes.map((solicitud, index) => {
            return (
                <Row key={index} className="mt-2 rowSolicitarPermisos">
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Tipo">
                                Tipo Solicitud
                            </Label>
                            <Input type="text" readOnly className="bold" value={"Cambio de horario"}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        <FormGroup>
                            <Label for="fechaDesde">
                                Fecha Desde
                            </Label>
                            <Input type="text" disabled value={formatDateToString(solicitud.fechaDesde)}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        <FormGroup>
                            <Label for="fechaHasta">
                                Fecha Hasta
                            </Label>
                            <Input type="text" disabled value={formatDateToString(solicitud.fechaHasta)}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        <FormGroup>
                            <Label for="horaEntrada">
                                Hora entrada
                            </Label>
                            <Input id="horaEntrada" type="text" disabled value={solicitud.horaEntrada}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        <FormGroup>
                            <Label for="horaSalida">
                                Hora salida
                            </Label>
                            <Input id="horaSalida" type="text" disabled value={solicitud.horaSalida}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="estado">
                                Estado
                            </Label>
                            <Input type="text" readOnly id="estado" value={solicitud.strEstadoSolicitud}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={3} className="d-flex ">
                        {
                            solicitud.refArchivo && solicitud.refArchivo !== null &&
                            <i className="fas fa-file-pdf opcion_eliminar_solicitud "
                                onClick={async () => await DownloadDocument(solicitud.refArchivo, datosUsuario, "Solicitud Cambio Horario.pdf")}
                                data-toggle="tooltip" data-placement="top" title="Solicitud Cambio Horario en pdf ">
                            </i>
                        }
                        {
                            solicitud.estadoSolicitud == "P" &&
                            <div className="align-self-center ml-2">
                                <i className="far fa-times-circle opcion_eliminar_solicitud"
                                    onClick={() => handleClickAnular(solicitud)}
                                    data-toggle="tooltip" data-placement="top" title="Anular Solicitud"
                                >
                                </i>
                            </div>
                        }
                    </Col>
                </Row>
            )
        })

        return htmlRowsSolicitudesPermisosIngresados;

    }

    const SolicitudesCambioHorario = useMemo(() => {
        if (stateSolCambioHorario.datosGenerales.solicitudesIngresadas.length !== 0) {
            const htmlSolicitud = GetHtmlSolicitudIngresada(stateSolCambioHorario.datosGenerales.solicitudesIngresadas);
            const solicitudes = (
                <div>
                    {htmlSolicitud}
                </div>
            )
            return solicitudes;
        }

    }, [stateSolCambioHorario.datosGenerales.solicitudesIngresadas])

    const validarCampos = () => {
        return horaDesde != "" && horaHasta != "" && fechaDesdeNueva != null
    }

    const limpiarFechasCardYModal = useCallback(
        () => {
            setfechaDesdeNueva(null)
            setHoraDesde("")
            setHoraHasta("")
            setObservacion("")
            sethorasSolicitadas("")
            setstateModalFormulario(defaultStateModalFormulario)
            setstateModalConfirmacion(defaultStateModalConfirmacion)
        },
        [stateModalFormulario],
    )

    const textareaStyle: React.CSSProperties = {
        textTransform: 'uppercase',
        width: '100%',
        minHeight: '70px',
        maxHeight: '70px',
        padding: '6px 12px',
        fontSize: '12px',
        lineHeight: '1.5',
        color: '#495057',
        backgroundColor: '#fff',
        backgroundClip: 'padding-box',
        border: '1px solid #ced4da',
        borderRadius: '0.25rem',
        transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
    };

    function GetHTMLSolicitudConfirmacion(solicitud: SolicitudPost | undefined): any {
        if (solicitud) {

            if (solicitud.HoraEntrada && solicitud.HoraSalida && solicitud.FechaDesde && solicitud.FechaHasta) {
                return (
                    <>
                        <div>
                            {`¿Está seguro que desea registrar su cambio de horario del permiso para el cuidado del recién nacido desde el día ${formatDateToString(solicitud.FechaDesde.toString())} hasta el día ${formatDateToString(solicitud.FechaHasta.toString())}, desde las ${solicitud.HoraEntrada} hasta las ${solicitud.HoraSalida}?`}

                        </div>

                    </>
                );
            }
        }

        return <div></div>;
    }

    function GetHTMLSolicitudCambioHorarioIngresadas(solicitudes: Array<SolicitudCambioHorarioIngresada>): any {
        var fechaActual = new Date();

        const htmlRowsSolicitudes = solicitudes.map((val, ind) => {
            var fechaDesde = val.fechaDesde ?? new Date()
            var fechaHasta = val.fechaHasta ?? new Date()
            const fila = (
                <Row key={"SolicitudesVacacionesUsuario" + ind} className="mt-2 rowSolicitarPermisos">
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Tipo">
                                Tipo Solicitud:
                            </Label>
                            <Input type="text" readOnly className="bold" value={"Cambio de horario"}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Fecha">
                                Fecha Desde:
                            </Label>
                            <Input type="text" readOnly className="bold" value={formatoFecha(fechaDesde.toString())}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Fecha">
                                Fecha Hasta:
                            </Label>
                            <Input type="text" readOnly className="bold" value={formatoFecha(fechaHasta.toString())}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Fecha">
                                Hora Entrada:
                            </Label>
                            <Input type="text" readOnly className="bold" value={val.horaEntrada}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Fecha">
                                Hora Salida:
                            </Label>
                            <Input type="text" readOnly className="bold" value={val.horaSalida}></Input>
                        </FormGroup>
                    </Col>
=======
//     const defaultStateEmpHorario: StateEmpleadoHorario = {
//         idpersonahorario: 0,
//         idhorariolaboral: 0,
//         fechaingreso: "",
//         fechaVigDesde: "",
//         fechaVigHasta: "",
//         horaEntrada: "",
//         horaSalida: "",
//     }

//     const defaultState: StateSolCambioHorario = {
//         datosGenerales: {
//             feriados: [],
//             historialSolicitudes: [], tieneAcuerdoMediosElectronicos: true,
//             empHorario: [],
//             horaInicioAlmuerzo: "",
//             horaFinAlmuerzo: "",
//             tiempoAlmuerzo: "",
//             solicitudesIngresadas:[]
//         },
//         loadingDG: false,
//         mensajeError: "",
//         idRegimenLaboral: [],
//         fechaControlHorario: new Date(),
//         puedeSolicitarPorHorario: false
//     }

//     const defaultStateModalHistoricoDetalle: StateModalHistoricoDetalle = {
//         loadingInformacion: false,
//         anio: -1,
//     }

//     const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
//         loading: false,
//         url: ""
//     }

//     const defaultStateModalFormulario: stateModalFormulario = {
//         url: "",
//         loadingFormulario: false,
//         tituloModal: 'Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido',
//         content: undefined,
//         solicitudNueva: undefined
//     }

//     const defaultStateModalConfirmacion: stateModalConfirmacion = {
//         solicitud: undefined,
//         showModal: false,
//         content: undefined,
//         tituloModal: 'Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido',
//     }

//     const defaultStateModal: stateModal = {
//         solicitud: undefined,
//         showModal: false,
//         content: undefined
//     }

//     const datosUsuario = authenticationService.currentUserValue.token;

//     const [stateSolCambioHorario, setstateSolCambioHorario] = useState<StateSolCambioHorario>(defaultState)
//     const [stateModalHistoricoDetalle, setstateModalHistoricoDetalle] = useState<StateModalHistoricoDetalle>(defaultStateModalHistoricoDetalle)
//     const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)
//     const [stateModalFormulario, setstateModalFormulario] = useState<stateModalFormulario>(defaultStateModalFormulario)
//     const [stateModalConfirmacion, setstateModalConfirmacion] = useState<stateModalConfirmacion>(defaultStateModalConfirmacion);
//     const [stateModal, setstateModal] = useState<stateModal>(defaultStateModal);

//     const [mensajeError, setMensajeError] = useState<string>("")
//     const [errorHoras, seterrorHoras] = useState<string | null>("")

//     const [horaEntradaAnterior, sethoraEntradaAnterior] = useState<string>("")
//     const [horaSalidaAnterior, sethoraSalidaAnterior] = useState<string>("")
//     const [fechaDesdeAnterior, setfechaDesdeAnterior] = useState<string | null>(null)
//     const [fechaHastaAnterior, setfechaHastaAnterior] = useState<string | null>(null)
//     const [feriados, setFeriados] = useState<Array<Date>>([])

//     const [fechaDesdeNueva, setfechaDesdeNueva] = useState<Date | null>(null)
//     const [horaDesde, setHoraDesde] = useState<string | null>("")
//     const [horaHasta, setHoraHasta] = useState<string | null>("")
//     const [observacion, setObservacion] = useState<string>("")
//     const [horasSolicitadas, sethorasSolicitadas] = useState<string | null>("")

//     const HORAS_TRABAJO_POR_DIA = 6;
//     const RANGO_INICIO_ALMUERZO = stateSolCambioHorario.datosGenerales.horaInicioAlmuerzo
//     const RANGO_FIN_ALMUERZO = stateSolCambioHorario.datosGenerales.horaFinAlmuerzo

//     const [horaMinPermitida, sethoraMinPermitida] = useState<string>("07:00")
//     const [horaMaxPermitida, sethoraMaxPermitida] = useState<string>("15:30")
//     const HORA_MAX_FIN_PERMITIDA = "15:30"
//     const TIEMPO_ALMUERZO = stateSolCambioHorario.datosGenerales.tiempoAlmuerzo
//     const maxLength = 140;

//     const MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS: string = "La solicitud no puede ser envíada por este medio porque no ha firmado el acuerdo de medios electrónicos. Por lo tanto, luego de dar click en aceptar, debe imprimir la presente solicitud, hacerla firmar físicamente por el directivo de su unidad y entregarla en la Unidad de Talento Humano";
//     const MENSAJE_ADVERTENCIA_CAMBIO_HORARIO = "El nuevo horario aplicará una vez que el directivo haya autorizado la solicitud.";


//     function HandleErrorInformacionGeneral(message?: string) {
//         const mensaje = message ?? "Ha ocurrido un error al intentar obtener informacion de sus solicitudes"
//         alertService.error(mensaje)
//     }

//     async function ObtenerDatosGenerales() {
//         setstateSolCambioHorario({ ...stateSolCambioHorario, loadingDG: true })
//         const respuesta = await ObtenerInformacionGeneralSolCambioHorario(HandleErrorInformacionGeneral)
//         const listaRegimenServidor: number[] = authenticationService.currentUserValue.regimen_usuario;
//         if (respuesta.status === 200) {
//             setstateSolCambioHorario({ ...defaultState, datosGenerales: respuesta.dataResponse, loadingDG: false, idRegimenLaboral: listaRegimenServidor })
//         }
//         else {
//             setstateSolCambioHorario({ ...defaultState, loadingDG: false, mensajeError: respuesta.errorMessage ?? "" })
//         }
//     }

//     useEffect(() => {
//         ObtenerDatosGenerales();
//     }, [])

//     useEffect(() => {
//         if (stateSolCambioHorario.idRegimenLaboral[0] == 7 || stateSolCambioHorario.idRegimenLaboral[0] == 8) {
//             sethoraMinPermitida("08:00")
//             sethoraMaxPermitida("16:30")
//         }
//     }, [stateSolCambioHorario])

//     useEffect(() => {
//         if (stateSolCambioHorario.datosGenerales.empHorario.length == 0) {
//             setMensajeError("Usted no tiene un permiso de cuidado del recién nacido en curso")
//         } else {
//             sethoraEntradaAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].horaEntrada)
//             sethoraSalidaAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].horaSalida)
//             setfechaDesdeAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].fechaVigDesde)
//             setfechaHastaAnterior(stateSolCambioHorario.datosGenerales.empHorario[0].fechaVigHasta)
//             setFeriados(stateSolCambioHorario.datosGenerales.feriados)
//             setMensajeError("")
//         }

//     }, [stateSolCambioHorario])

//     function OnChangeHoraDesde(e: any) {
//         setHoraDesde(e.target.value);
//     }

//     function OnChangeHoraHasta(e: any) {
//         setHoraHasta(e.target.value);
//     }

//     const handleObservacionChange = (event) => {
//         const valor = event.target.value.toUpperCase();
//         if (valor.length <= maxLength) {
//             setObservacion(valor);
//         }

//     };

//     const DatePickerFechaDesde = useCallback((permiso: boolean) => {
//         const feriadosFechas = feriados.map((val, ind) => {
//             return new Date(val)
//         })

//         const fechaDesdeAnteriorDate = fechaDesdeAnterior ? new Date(fechaDesdeAnterior) : "";
//         const fechaHastaAnteriorDate = fechaHastaAnterior ? new Date(fechaHastaAnterior) : null;

//         var excludeDates = [...feriadosFechas];
//         const fechaMinima = SumarDiasFecha(fechaDesdeAnteriorDate, 1);
//         const fechaMaxima = fechaHastaAnteriorDate


//         const handleChangeFechaDesde = (e: Date) => {
//             setfechaDesdeNueva(e)
//         };

//         return (
//             <Datepicker
//                 value={fechaDesdeNueva}
//                 disabled={!permiso}
//                 name="fechadesde"
//                 id="fechadesde"
//                 onChange={handleChangeFechaDesde}
//                 min={fechaMinima}
//                 max={fechaMaxima}
//                 showDisabledMonthNavigation={true}
//                 excludeDates={excludeDates}
//                 filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, feriados)}
//                 dayClassName={(date: Date) => isFeriado(date, feriados)}
//             />
//         )
//     }, [feriados, fechaDesdeNueva]);

//     const inputHoraDesde = useCallback(
//         () => {
//             return (
//                 <Input type="time" className="inputTime" value={horaDesde} onChange={(e) => OnChangeHoraDesde(e)} style={{ padding: "5px 1px" }} />
//             )
//         },
//         [horaDesde]
//     )

//     const inputHoraHasta = useCallback(
//         () => {
//             return (
//                 <>
//                     <Input disabled={(horaDesde !== undefined && horaHasta === undefined && errorHoras !== "") || horaDesde === undefined || horaDesde === ""} type="time" className="inputTime" min={"08:01"} max={"16:30"} value={horaHasta} onChange={(e) => OnChangeHoraHasta(e)} style={{ padding: "5px 1px" }} />
//                 </>
//             )
//         },
//         [horaDesde, horaHasta, errorHoras]
//     )
//     useEffect(() => {

//         if ((horaDesde !== undefined && horaDesde !== "" && horaDesde !== null)) {

//             const fechaEscogida = new Date();
//             const [hora_entrada, minuto_entrada] = horaDesde.split(":");
//             const [hora_entrada_permitida, minuto_entrada_permitida] = horaMinPermitida.split(":");
//             const horaEntradaDelDia = add(fechaEscogida, { hours: +hora_entrada, minutes: +minuto_entrada })
//             const horaEntradaPermitidaDelDia = add(fechaEscogida, { hours: +hora_entrada_permitida, minutes: +minuto_entrada_permitida })
//             if (horaEntradaDelDia < horaEntradaPermitidaDelDia) {
//                 seterrorHoras("La hora de entrada no puede ser menor a la hora permitida por su régimen.")
//             } else {
//                 seterrorHoras("")
//             }
//         }
//     }, [horaDesde])

//     useEffect(() => {

//         if ((horaHasta !== undefined && horaHasta !== "" && horaHasta !== null)) {

//             const fechaEscogida = new Date();
//             const [hora_salida, minuto_salida] = horaHasta.split(":");
//             const [hora_salida_permitida, minuto_salida_permitida] = horaMaxPermitida.split(":");
//             const horaSalidaDelDia = add(fechaEscogida, { hours: +hora_salida, minutes: +minuto_salida })
//             const horaSalidaPermitidaDelDia = add(fechaEscogida, { hours: +hora_salida_permitida, minutes: +minuto_salida_permitida })
//             if (horaSalidaDelDia > horaSalidaPermitidaDelDia) {
//                 seterrorHoras("La hora de salida no puede ser maypor a la hora permitida por su régimen.")
//             } else {
//                 seterrorHoras("")
//             }
//         }
//     }, [horaHasta])

//     useEffect(() => {

//         if ((horaDesde !== undefined && horaDesde !== "" && horaDesde !== null) && (horaHasta !== undefined && horaHasta !== "" && horaHasta !== null)) {

//             const fechaEscogida = new Date();

//             const horaDesdeAnterior = stateSolCambioHorario.datosGenerales.empHorario[0].horaEntrada
//             const horaHastaAnterior = stateSolCambioHorario.datosGenerales.empHorario[0].horaSalida

//             const [hora_entrada, minuto_entrada] = horaDesde.split(":");
//             const [hora_salida, minuto_salida] = horaHasta.split(":");

//             const [hora_entrada_permitida, minuto_entrada_permitida] = horaMinPermitida.split(":");
//             const [hora_salida_permitida, minuto_salida_permitida] = horaMaxPermitida.split(":");

//             const tiempoAlmuerzo = TIEMPO_ALMUERZO.split(':');
//             const tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);

//             const horaEntradaDelDia = add(fechaEscogida, { hours: +hora_entrada, minutes: +minuto_entrada })
//             const horaSalidaDelDia = add(fechaEscogida, { hours: +hora_salida, minutes: +minuto_salida })

//             const horaEntradaPermitidaDelDia = add(fechaEscogida, { hours: +hora_entrada_permitida, minutes: +minuto_entrada_permitida })
//             const horaSalidaPermitidaDelDia = add(fechaEscogida, { hours: +hora_salida_permitida, minutes: +minuto_salida_permitida })


//             const diferenciaHorasHorarioLaboral = (+differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia)) / 60;
//             const diferenciaMinutos = +differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia);
//             const diferencia = toHoursAndMinutes(diferenciaMinutos - tiempoAlmuerzoMinutos);
//             sethorasSolicitadas(diferencia);
//             if (diferenciaHorasHorarioLaboral < 0) {
//                 seterrorHoras("La hora de salida debe de ser mayor que la hora de entrada.")
//             } else if (diferenciaHorasHorarioLaboral > 0 && diferenciaHorasHorarioLaboral != 6.5) {
//                 seterrorHoras("El horario laboral debe de tener una duración de 6 horas.")
//             } else if (diferenciaHorasHorarioLaboral > 0 && diferenciaHorasHorarioLaboral == 6.5 && horaDesde == horaDesdeAnterior && horaHasta == horaHastaAnterior) {
//                 seterrorHoras("La hora de entrada o la hora de salida deben de ser diferentes al horario ya existente.")
//             } else if (horaEntradaDelDia < horaEntradaPermitidaDelDia) {
//                 seterrorHoras("La hora de entrada no puede ser menor a la hora permitida por su régimen.")
//             } else if (horaSalidaDelDia > horaSalidaPermitidaDelDia) {
//                 seterrorHoras("La hora de salida no puede ser menor a la hora permitida por su régimen.")
//             } else {
//                 seterrorHoras("")
//             }
//         }
//     }, [horaDesde, horaHasta])


//     function GetHtmlSolicitudIngresada(solicitudes: SolicitudCambioHorarioIngresada[]) {
//         console.log(solicitudes)
//         const htmlRowsSolicitudesPermisosIngresados = solicitudes.map((solicitud, index) => {
//             return (
//                 <Row key={index} className="mt-2 rowSolicitarPermisos">
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="Tipo">
//                                 Tipo Solicitud
//                             </Label>
//                             <Input type="text" readOnly className="bold" value={"Cambio de horario"}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={1}>
//                         <FormGroup>
//                             <Label for="fechaDesde">
//                                 Fecha Desde
//                             </Label>
//                             <Input type="text" disabled value={formatDateToString(solicitud.fechaDesde)}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={1}>
//                         <FormGroup>
//                             <Label for="fechaHasta">
//                                 Fecha Hasta
//                             </Label>
//                             <Input type="text" disabled value={formatDateToString(solicitud.fechaHasta)}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={1}>
//                         <FormGroup>
//                             <Label for="horaEntrada">
//                                 Hora entrada
//                             </Label>
//                             <Input id="horaEntrada" type="text" disabled value={solicitud.horaDesde}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={1}>
//                         <FormGroup>
//                             <Label for="horaSalida">
//                                 Hora salida
//                             </Label>
//                             <Input id="horaSalida" type="text" disabled value={solicitud.horaHasta}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="estado">
//                                 Estado
//                             </Label>
//                             <Input type="text" readOnly id="estado" value={solicitud.strEstadoSolicitud}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={3} className="d-flex ">
//                         {
//                             solicitud.refArchivo && solicitud.refArchivo !== null &&
//                             <i className="fas fa-file-pdf opcion_eliminar_solicitud "
//                                 onClick={async () => await DownloadDocument(solicitud.refArchivo, datosUsuario, "Solicitud Cambio Horario.pdf")}
//                                 data-toggle="tooltip" data-placement="top" title="Solicitud Cambio Horario en pdf ">
//                             </i>
//                         }
//                         {
//                             solicitud.estadoSolicitud == "P" &&
//                             <div className="align-self-center ml-2">
//                                 <i className="far fa-times-circle opcion_eliminar_solicitud"
//                                     onClick={() => handleClickAnular(solicitud)}
//                                     data-toggle="tooltip" data-placement="top" title="Anular Solicitud"
//                                 >
//                                 </i>
//                             </div>
//                         }
//                     </Col>
//                 </Row>
//             )
//         })

//         return htmlRowsSolicitudesPermisosIngresados;

//     }

//     const SolicitudesCambioHorario = useMemo(() => {
//         if (stateSolCambioHorario.datosGenerales.solicitudesIngresadas.length !== 0) {
//             const htmlSolicitud = GetHtmlSolicitudIngresada(stateSolCambioHorario.datosGenerales.solicitudesIngresadas);
//             const solicitudes = (
//                 <div>
//                     {htmlSolicitud}
//                 </div>
//             )
//             return solicitudes;
//         }

//     }, [stateSolCambioHorario.datosGenerales.solicitudesIngresadas])

//     const validarCampos = () => {
//         return horaDesde != "" && horaHasta != "" && fechaDesdeNueva != null
//     }

//     const limpiarFechasCardYModal = useCallback(
//         () => {
//             setfechaDesdeNueva(null)
//             setHoraDesde("")
//             setHoraHasta("")
//             setObservacion("")
//             sethorasSolicitadas("")
//             setstateModalFormulario(defaultStateModalFormulario)
//             setstateModalConfirmacion(defaultStateModalConfirmacion)
//         },
//         [stateModalFormulario],
//     )

//     const textareaStyle: React.CSSProperties = {
//         textTransform: 'uppercase',
//         width: '100%',
//         minHeight: '70px',
//         maxHeight: '70px',
//         padding: '6px 12px',
//         fontSize: '12px',
//         lineHeight: '1.5',
//         color: '#495057',
//         backgroundColor: '#fff',
//         backgroundClip: 'padding-box',
//         border: '1px solid #ced4da',
//         borderRadius: '0.25rem',
//         transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
//     };

//     function GetHTMLSolicitudConfirmacion(solicitud: SolicitudPost | undefined): any {
//         if (solicitud) {

//             if (solicitud.HoraEntrada && solicitud.HoraSalida && solicitud.FechaDesde && solicitud.FechaHasta) {
//                 return (
//                     <>
//                         <div>
//                             {`¿Está seguro que desea registrar su cambio de horario del permiso para el cuidado del recién nacido desde el día ${formatDateToString(solicitud.FechaDesde.toString())} hasta el día ${formatDateToString(solicitud.FechaHasta.toString())}, desde las ${solicitud.HoraEntrada} hasta las ${solicitud.HoraSalida}?`}

//                         </div>

//                     </>
//                 );
//             }
//         }

//         return <div></div>;
//     }

//     function GetHTMLSolicitudCambioHorarioIngresadas(solicitudes: Array<SolicitudCambioHorarioIngresada>): any {
//         var fechaActual = new Date();

//         const htmlRowsSolicitudes = solicitudes.map((val, ind) => {
//             var fechaDesde = val.fechaDesde ?? new Date()
//             var fechaHasta = val.fechaHasta ?? new Date()
//             const fila = (
//                 <Row key={"SolicitudesVacacionesUsuario" + ind} className="mt-2 rowSolicitarPermisos">
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="Tipo">
//                                 Tipo Solicitud:
//                             </Label>
//                             <Input type="text" readOnly className="bold" value={"Cambio de horario"}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="Fecha">
//                                 Fecha Desde:
//                             </Label>
//                             <Input type="text" readOnly className="bold" value={formatoFecha(fechaDesde.toString())}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="Fecha">
//                                 Fecha Hasta:
//                             </Label>
//                             <Input type="text" readOnly className="bold" value={formatoFecha(fechaHasta.toString())}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="Fecha">
//                                 Hora Entrada:
//                             </Label>
//                             <Input type="text" readOnly className="bold" value={val.horaEntrada}></Input>
//                         </FormGroup>
//                     </Col>
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="Fecha">
//                                 Hora Salida:
//                             </Label>
//                             <Input type="text" readOnly className="bold" value={val.horaSalida}></Input>
//                         </FormGroup>
//                     </Col>
>>>>>>> 6e3c6333dc3a302f96d9697ace755439e731f426
                    
//                     <Col md={2}>
//                         <FormGroup>
//                             <Label for="Fecha">
//                                 Estado:
//                             </Label>
//                             <Input type="text" readOnly id="estadoSolicitudReplanificacion" value={val.strEstadoSolicitud}></Input>
//                         </FormGroup>
//                     </Col>
//                 </Row>
//             )
//             return fila;

//         })



//         return htmlRowsSolicitudes;
//     }

//     const AuxiliarCrearSolicitudPost = useCallback(
//         () => {
//             const formData = new FormData()
//             if (horaDesde != null && horaHasta != null && fechaDesdeNueva && fechaHastaAnterior) {
//                 formData.append('FechaDesde', PruebaSolucion2(fechaDesdeNueva).toString())
//                 formData.append('FechaHasta', PruebaSolucion2(fechaHastaAnterior).toString())
//                 formData.append('Observacion', observacion)
//                 formData.append('HoraEntrada', horaDesde.toString())
//                 formData.append('HoraSalida', horaHasta.toString())

//                 return formData;
//             }
            

//         },
//         [horaDesde, horaHasta, observacion, fechaDesdeNueva],
//     )

//     const handleClickConfirmar = (solicitud: SolicitudPost | undefined) => {
//         const content: any = GetHTMLSolicitudConfirmacion(solicitud)
//         let tituloModal: string | null = "";
//         if (solicitud !== undefined) {
//             tituloModal = "Solicitud de cambio de horario para permiso de cuidado del recién nacido"
//         }
//         setstateModalConfirmacion({
//             showModal: true,
//             solicitud,
//             content,
//             tituloModal
//         });
//     }

//     const handleClickSolicitar = useCallback(
//         async () => {
//             var titulo = "";
//             var respuestaSolicitud: ResponseRequest = { status: -1 };
//             let solicitudNueva: SolicitudPost = {
//                 FechaDesde: "",
//                 FechaHasta: "",
//                 HoraSalida: "",
//                 HoraEntrada: "",
//                 Observacion: "",
//             };
            
//             if (stateSolCambioHorario.datosGenerales.solicitudesIngresadas.length > 0) {
//                 seterrorHoras("Usted ya tiene una solicitud de cambio de horario de permiso para cuidado del recién nacido. Si desea ingresar una solicitud nueva debe de anular la solicitud existente.")
//                 return
//             }

//             if (fechaDesdeNueva !== undefined && fechaDesdeNueva !== null) {
                
//                 solicitudNueva = {
//                     FechaDesde: fechaDesdeNueva,
//                     FechaHasta: fechaHastaAnterior,
//                     HoraSalida: horaHasta,
//                     HoraEntrada: horaDesde,
//                     Observacion: observacion,
//                 }

//                 respuestaSolicitud = await SolicitarFormulario(solicitudNueva, stateSolCambioHorario.datosGenerales.tieneAcuerdoMediosElectronicos);
//             }

//             if (respuestaSolicitud.status === 200) {


//                 var content: any = undefined;

//                 if (!stateSolCambioHorario.datosGenerales.tieneAcuerdoMediosElectronicos) {
//                     content = (
//                         <AlertNew
//                             mensaje={MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS}
//                             oncloseElement={() => ""}
//                             closeButton={false}

//                         />
//                     )
//                 }

//                 titulo = "Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido"

                
//                 setstateModalFormulario({ url: respuestaSolicitud.dataResponse, loadingFormulario: false, tituloModal: titulo, content, solicitudNueva })

//             }
//             else {
//                 alertService.error(respuestaSolicitud.errorMessage ?? "");
               

//             }
//             ScrollToTop();
//         }, [horaDesde, horaHasta, fechaDesdeNueva, observacion, stateSolCambioHorario.datosGenerales.tieneAcuerdoMediosElectronicos]
//     )
//     const OnClickAccionModalFormulario = useCallback(async (): Promise<number> => {

//         var respuesta: ResponseRequest = { status: -1 };
//         if ((fechaDesdeNueva !== null && horaDesde !== null && horaHasta !== null)) {
            

//             const solicitudNueva = AuxiliarCrearSolicitudPost();
//             if (solicitudNueva === undefined) {
//                 alertService.error("No ha sido posible ingresar la solicitud");
//             }
//             else {
//                 respuesta = await SolicitarCambioHorarioCreacion(solicitudNueva);
//                 await ObtenerDatosGenerales()
//             }

//             if (respuesta.status === 200) {
//                 // setstateCard({ ...stateCard, fechaDesde: null, fechaHasta: null })
//                 alertService.success("La solicitud ha sido guardada con éxito");
//                 limpiarFechasCardYModal()
//                 await ObtenerDatosGenerales()
               

//                 ScrollToTop();
//                 return 200;
//             }
//             else {
//                 alertService.error(respuesta.errorMessage ?? "No ha sido posible ingresar la solicitud de cambio de horario del permiso de cuidado del recién nacido.Intente más tarde")
//                 limpiarFechasCardYModal()
                
//                 ScrollToTop();
//                 return respuesta.status;
//             }

//         } else {
//             // Si no se cumple la condición, devolver un código de error
//             return -1;
//         }



//     }
//         , [limpiarFechasCardYModal, AuxiliarCrearSolicitudPost])

//     const handleClickAnular = (solicitud: SolicitudCambioHorarioIngresada) => {
//         const content: any = GetHTMLSolicitudCambioHorarioIngresadas([solicitud])
//         setstateModal({
//             showModal: true,
//             solicitud,
//             content
//         });
//     }

//     async function AnularSolicitud(idSolicitud: number) {
//         const statusAnulacion = await AnularSolicitudCambioHorario(idSolicitud);
//         if (statusAnulacion === 1) {
//             alertService.success("La solicitud ha sido anulada con éxito");
//             await ObtenerDatosGenerales()
//         }
//         else {
//             alertService.error("Ha ocurrido un inconveniente al intentar anular la solicitud");
//         }
//         return statusAnulacion;
//     }

//     const ModalEliminarSolicitudesCambioHorario = useMemo(() => {
//         return (
//             <ModalConfirmacion
//                 show={stateModal.showModal && (stateModal.solicitud?.idSolicitud ?? -1) > -1}
//                 size="xl"
//                 mensajeConfirmacion={'¿Desea anular la solicitud?'}
//                 classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
//                 tituloModal='Anulación de Solicitud'
//                 nombreBotonAccion='Aceptar'
//                 nombreBotonCerrarModal='Cancelar'
//                 onClose={() => setstateModal(defaultStateModal)}
//                 asyncAccion={true}
//                 asyncClose={true}
//                 closeAfterAccion={true}
//                 hideBotonCerrar={false}
//                 asyncOnClick={async () => AnularSolicitud(stateModal.solicitud?.idSolicitud ?? -1)}
//                 contentModal={stateModal.content}
//                 classNameAllModal={""}

//             />
//         )

//     }, [stateModal])

//     const onClickVerDoc = useCallback(
//         async (referencia: string) => {
//             console.log(referencia)
//             setstateModalVP({ ...stateModalVP, loading: true })
//             const datosUsuario: UserData = authenticationService.currentUserValue;
//             const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
//             setstateModalVP({ ...stateModalVP, loading: false, url })
//         }, [stateModalVP])

//     const tablaHistorialSolicitudes = useMemo(() => {
//         if (stateSolCambioHorario.loadingDG) {
//             return <Cargando />
//         }
//         else if (stateSolCambioHorario.mensajeError) {
//             return <div>No ha sido posible obtener información</div>
//         }
//         else if (!stateSolCambioHorario.mensajeError && stateSolCambioHorario.datosGenerales.historialSolicitudes.length === 0) {
//             return <div>No hay solicitudes por mostrar</div>

//         }
//         else if (!stateSolCambioHorario.loadingDG && stateSolCambioHorario.datosGenerales.historialSolicitudes.length > 0) {
//             return (
//                 <TableHistorialSolicitudCambioHorario
//                     dataFilas={stateSolCambioHorario.datosGenerales.historialSolicitudes}
//                     onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
//                 />


            )
        }
    }, [stateSolCambioHorario])*/

//             )
//         }
    // }, [stateSolCambioHorario])



    return (
        <></>

        /*<div className="content">
            <div className="titulo_seccion mb-5"> SOLICITUD DE CAMBIO DE HORARIO DE PERMISO PARA CUIDADO DEL RECIÉN NACIDO</div>
            <Row>
                <Col md={{ size: 12 }}>
                    <small className='small-error-mensaje '>{mensajeError}</small>
                </Col>
            </Row>
            {stateSolCambioHorario.datosGenerales.empHorario.length !== 0 && (
                <>

        // <div className="content">
        //     <div className="titulo_seccion mb-5"> SOLICITUD DE CAMBIO DE HORARIO DE PERMISO PARA CUIDADO DEL RECIÉN NACIDO</div>
        //     <Row>
        //         <Col md={{ size: 12 }}>
        //             <small className='small-error-mensaje '>{mensajeError}</small>
        //         </Col>
        //     </Row>
        //     {stateSolCambioHorario.datosGenerales.empHorario.length !== 0 && (
        //         <>
>>>>>>> 6e3c6333dc3a302f96d9697ace755439e731f426
                
        //         <Row className="">
        //         <Col md={12}>
        //             <AlertNew
        //                 cabeceraTitulo={"¡¡ADVERTENCIA!!"}
        //                 mensaje={MENSAJE_ADVERTENCIA_CAMBIO_HORARIO}
        //                 tipo={TiposAlerta.ADVERTENCIA}
        //                 oncloseElement={() => { ; }}
        //             />
        //         </Col>
        //     </Row>
        //     <Row>
        //         <Col md={12} xl={12}>

        //             <Form autoComplete="off">
        //                 <Row>
        //                     <Col md={12}>
        //                         <Label>
        //                             HORARIO ANTERIOR
        //                         </Label>
        //                     </Col>
        //                 </Row>
        //                 <Row>
        //                     <>
        //                         <Col md={1}>
        //                             <FormGroup>
        //                                 <Label for="horaentrada">
        //                                     Hora Entrada
        //                                 </Label>
        //                                 <Input value={horaEntradaAnterior} disabled />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={1}>
        //                             <FormGroup>
        //                                 <Label for="horasalida">
        //                                     Hora Salida
        //                                 </Label>
        //                                 <Input value={horaSalidaAnterior} disabled />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={2}>
        //                             <FormGroup>
        //                                 <Label for="fechadesde">
        //                                     Fecha Desde
        //                                 </Label>
        //                                 <Input value={formatDateToString(fechaDesdeAnterior)} disabled />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={2}>
        //                             <FormGroup>
        //                                 <Label for="fechahasta">
        //                                     Fecha Hasta
        //                                 </Label>
        //                                 <Input value={formatDateToString(fechaHastaAnterior)} disabled />
        //                             </FormGroup>
        //                         </Col>
                               
        //                     </>
        //                 </Row>
        //                 <Row>
        //                     <Col md={12}>
        //                         <Label className="pt-2">
        //                             HORARIO PROPUESTO
        //                         </Label>
        //                     </Col>
        //                 </Row>
        //                 <Row className="rowErroresHoras">
        //                     <Col md={{ size: 12 }}>
        //                         <small className='small-error-mensaje '>{errorHoras}</small>
        //                     </Col>
        //                 </Row>
        //                 <Row>
        //                     <>
        //                         <Col md={1}>
        //                             <FormGroup>
        //                                 <Label for="horaentrada">
        //                                     Hora Entrada*
        //                                 </Label>
        //                                 {inputHoraDesde()}
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={1}>
        //                             <FormGroup>
        //                                 <Label for="horasalida">
        //                                     Hora Salida*
        //                                 </Label>
        //                                 {inputHoraHasta()}
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={1}>
        //                             <FormGroup>
        //                                 <Label for="tiemporeceso">
        //                                     Receso
        //                                 </Label>
        //                                 <Input type="text" value={TIEMPO_ALMUERZO === undefined ? "" : TIEMPO_ALMUERZO} readOnly id="tiemporeceso"></Input>
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={1}>
        //                             <FormGroup>
        //                                 <Label for="duracion">
        //                                     Duración
        //                                 </Label>
        //                                 <Input type="text" value={horasSolicitadas === undefined ? "" : horasSolicitadas} readOnly id="horas_solicitadas"></Input>
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={2}>
        //                             <FormGroup>
        //                                 <Label for="fechadesde">
        //                                     Fecha Desde*
        //                                 </Label>
        //                                 {DatePickerFechaDesde(true)}
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={2}>
        //                             <FormGroup>
        //                                 <Label for="fechahasta">
        //                                     Fecha Hasta
        //                                 </Label>
        //                                 <Input value={formatDateToString(fechaHastaAnterior)} disabled />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={3}>
        //                             <FormGroup>
        //                                 <Label for="archivo">
        //                                     Observación (Máximo 140 caracteres)
        //                                 </Label>
        //                                 <textarea
        //                                     value={observacion}
        //                                     onChange={handleObservacionChange}
        //                                     style={textareaStyle}
        //                                     maxLength={maxLength}
        //                                 />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col md={1} className="align-self-start d-flex justify-content-start mt-3">
        //                             <Button onClick={() => handleClickSolicitar()} disabled={errorHoras !== "" || mensajeError !== "" || !validarCampos()}>SOLICITAR </Button>
        //                         </Col>
        //                     </>
        //                 </Row>
                        

        //             </Form>
        //         </Col>
        //             </Row>
        //         </>
        //     )}
            

            {SolicitudesCambioHorario}
            {tablaHistorialSolicitudes}
            {ModalEliminarSolicitudesCambioHorario }
            <ModalVistaPreviaDocumentosAccion
                show={stateModalFormulario.url !== "" || stateModalFormulario.loadingFormulario}
                accionOnAccept={true}
                cargandoDatos={stateModalFormulario.loadingFormulario}
                onClose={() => limpiarFechasCardYModal()}
                size="xl"
                tituloModal={stateModalFormulario.tituloModal}
                urlArchivo={stateModalFormulario.url}
                disabledbuttonCondition={stateModalFormulario.loadingFormulario}
                onAccion={() => handleClickConfirmar(stateModalFormulario.solicitudNueva)}
                modalContent={stateModalFormulario.content}
            />
            <ModalConfirmacion
                show={stateModalConfirmacion.showModal}
                asyncAccion={true}
                asyncClose={true}
                onClose={() => limpiarFechasCardYModal()}
                size="xl"
                tituloModal={"Confirmación de " + stateModalConfirmacion.tituloModal?.toLowerCase()}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={async () => await OnClickAccionModalFormulario()}
                contentModal={stateModalConfirmacion.content}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion=""
            />
            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de cambio de horario de permiso para el cuidado del recién nacido'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />
        </div>*/

        //     {SolicitudesCambioHorario}
        //     {tablaHistorialSolicitudes}
        //     {ModalEliminarSolicitudesCambioHorario }
        //     <ModalVistaPreviaDocumentosAccion
        //         show={stateModalFormulario.url !== "" || stateModalFormulario.loadingFormulario}
        //         accionOnAccept={true}
        //         cargandoDatos={stateModalFormulario.loadingFormulario}
        //         onClose={() => limpiarFechasCardYModal()}
        //         size="xl"
        //         tituloModal={stateModalFormulario.tituloModal}
        //         urlArchivo={stateModalFormulario.url}
        //         disabledbuttonCondition={stateModalFormulario.loadingFormulario}
        //         onAccion={() => handleClickConfirmar(stateModalFormulario.solicitudNueva)}
        //         modalContent={stateModalFormulario.content}
        //     />
        //     <ModalConfirmacion
        //         show={stateModalConfirmacion.showModal}
        //         asyncAccion={true}
        //         asyncClose={true}
        //         onClose={() => limpiarFechasCardYModal()}
        //         size="xl"
        //         tituloModal={"Confirmación de " + stateModalConfirmacion.tituloModal?.toLowerCase()}
        //         nombreBotonAccion={"SI"}
        //         nombreBotonCerrarModal={"NO"}
        //         asyncOnClick={async () => await OnClickAccionModalFormulario()}
        //         contentModal={stateModalConfirmacion.content}
        //         closeAfterAccion={true}
        //         hideBotonCerrar={false}
        //         mensajeConfirmacion=""
        //     />
        //     <ModalVistaPreviaDocumentos
        //         cargandoDatos={stateModalVP.loading}
        //         onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
        //         show={stateModalVP.loading || stateModalVP.url !== ""}
        //         size="xl"
        //         tituloModal='Documento de cambio de horario de permiso para el cuidado del recién nacido'
        //         urlArchivo={stateModalVP.url}
        //         botonCerrar={true}
        //     />
        // </div>

    )
}
